/**
 * Multi-row slider: initializes Swiper for .multi_row_slider sections
 * with 2-row grid layout (same behavior as shop_by_slider, multi-row).
 * Requires Swiper (swiper-bundle.min.js) to be loaded globally.
 */
(function() {
  'use strict';

  /**
   * Initializes the "View More" / "Hide" toggle for mobile grid items.
   * Shows hidden items when View More is clicked; hides them again when Hide is clicked.
   * @param {HTMLElement} sectionEl - The section container element
   */
  function initViewMore(sectionEl) {
    const grid = sectionEl.querySelector('[data-mobile-grid]');
    const viewMoreBtn = sectionEl.querySelector('[data-view-more-btn]');
    const hideBtn = sectionEl.querySelector('[data-hide-btn]');
    if (!grid || !viewMoreBtn) return;

    viewMoreBtn.addEventListener('click', function() {
      var hidden = grid.querySelectorAll('.multi-row-slider__mobile-item--hidden');
      hidden.forEach(function(el) {
        el.classList.add('is_visible');
      });
      viewMoreBtn.classList.add('is_hidden');
      if (hideBtn) hideBtn.classList.remove('is_hidden');
    });

    if (hideBtn) {
      hideBtn.addEventListener('click', function() {
        var revealed = grid.querySelectorAll('.multi-row-slider__mobile-item--hidden.is_visible');
        revealed.forEach(function(el) {
          el.classList.remove('is_visible');
        });
        hideBtn.classList.add('is_hidden');
        viewMoreBtn.classList.remove('is_hidden');
      });
    }
  }

  /**
   * Initializes a single multi-row slider section: View More toggle and Swiper instance.
   * Configures group-slides mode (desktop) or grid mode based on the slider markup.
   * @param {HTMLElement} sectionEl - The section container element
   */
  function initSection(sectionEl) {
    initViewMore(sectionEl);

    var swiperEl = sectionEl.querySelector('.multi-row-slider__slider .swiper');
    if (!swiperEl || swiperEl.swiper) return;

    var prevEl = sectionEl.querySelector('.multi-row-slider__nav-btn--prev');
    var nextEl = sectionEl.querySelector('.multi-row-slider__nav-btn--next');

    var isGroupSlides = swiperEl.classList.contains('swiper--group-slides');

    if (isGroupSlides) {
      new Swiper(swiperEl, {
        slidesPerView: 1.49,
        spaceBetween: 0,
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl
        }
      });
    } else {
      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        grid: {
          rows: 2,
          fill: 'row'
        },
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl
        },
        breakpoints: {
          900: {
            spaceBetween: 8
          }
        }
      });
    }
  }

  /**
   * Initializes all .multi_row_slider sections on the page.
   */
  function initAll() {
    document.querySelectorAll('.multi_row_slider').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.MultiRowSlider = {
    /**
     * Initializes the multi-row slider for a given container.
     * Accepts either the section element itself or a parent containing .multi_row_slider.
     * @param {HTMLElement} container - Container element (section or parent of section)
     */
    init: function(container) {
      if (container && container.classList && container.classList.contains('multi_row_slider')) {
        initSection(container);
      } else if (container) {
        var section = container.querySelector && container.querySelector('.multi_row_slider') || container.closest && container.closest('.multi_row_slider');
        if (section) initSection(section);
      }
    }
  };
})();
